import { render, staticRenderFns } from "./Toggles.vue?vue&type=template&id=1b057a55&"
import script from "./Toggles.vue?vue&type=script&lang=js&"
export * from "./Toggles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Toggles.vue"
export default component.exports